import { render, staticRenderFns } from "./BlogIcon.vue?vue&type=template&id=7923cfc0&"
import script from "./BlogIcon.vue?vue&type=script&lang=ts&"
export * from "./BlogIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports